import * as Sentry from '@sentry/nextjs';
import { CouponHistory } from 'src/models/coupon/CouponHistory';
import { Coupon, CouponHistorySchema, CouponSchema } from 'src/models/coupon/schema';
import { Left, Right } from 'src/utils/either';
import { errorMessage } from 'src/utils/errorMessage';
import { shoppingApiBaseUrl } from 'src/utils/shoppingApiBaseUrl';
import { getLocaleFromUrl } from 'src/utils/subdomain';
import { getRequest, postRequest } from '../wa/gateways/api/wamazingApi';
import { ApiResponse } from './response/ApiResponse';

const fetchCoupons = async (): Promise<ApiResponse<CouponHistory[]>> => {
  try {
    const response = await getRequest<CouponHistorySchema>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/coupon_histories',
    });
    return new Right(response.couponHistories.map((coupon) => new CouponHistory(coupon)));
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

const fetchCouponList = async (path: string): Promise<ApiResponse<Coupon[]>> => {
  try {
    const response = await getRequest<Coupon[]>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path,
    });
    return new Right(response);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

const postCoupon = async (promoCode: string): Promise<ApiResponse<CouponHistory>> => {
  try {
    const response = await postRequest<{
      couponHistory: CouponSchema;
      errors: string[];
    }>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/coupon_histories',
      params: {
        promoCode,
      },
    });
    if (response.errors && response.errors.length > 0) {
      return new Left({ errors: response.errors });
    }
    return new Right(new CouponHistory(response.couponHistory));
  } catch (e) {
    Sentry.captureException(errorMessage(e));
    return new Left({ errors: [errorMessage(e)] });
  }
};

export { fetchCoupons, fetchCouponList, postCoupon };
